module.exports = __webpack_public_path__ + "img/Question.078deca8.svg";